import techdoctpl from './techDoc.tpl.html';
import {
  getTechnicalInformationById,
  getLoading,
} from '../../../../reducers/techDoc';

import { getBITemplateById } from '../../../../reducers/businessInformationTemplates';

export class TechDoc {
  constructor($scope, $ngRedux, actionsFactory, $translate, $location, $anchorScroll) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      $location,
      $anchorScroll,
      showConfirmationModal: false,
      modalItem: {},
    });
    const unsubscribe = $ngRedux.connect(TechDoc.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }
  static mapStateToThis(state) {
    const techDoc = getTechnicalInformationById(state, state.router.currentParams.techDocId);
    const template = getBITemplateById(state, techDoc && techDoc.template);
    return {
      auth: state.authentication,
      router: state.router,
      techDoc,
      template,
      loading: getLoading(state),
      company: state.companies.byId[state.router.currentParams.id],
    };
  }

  $onInit() {
    this.reqTechDoc(this.router.currentParams.id, this.router.currentParams.techDocId);
  }

  scrollTo(hash) {
    this.$location.hash(hash);
    this.$anchorScroll();
  }

  save() {
    this.saveTechDocStart(
      this.router.currentParams.id,
      this.router.currentParams.techDocId,
      this.techDoc.content,
    );
  }

  partialSave() {
    this.updateTechDoc(
      this.router.currentParams.id,
      this.router.currentParams.techDocId,
      this.techDoc.content,
    );
  }

  setTechDocToDraft() {
    this.setTechDocToDraftStart(
      this.router.currentParams.id,
      this.router.currentParams.techDocId,
    );
  }

  isEditable() {
    return this.techDoc.source === 'custom' && this.techDoc.status !== 'available';
  }

  doShowConfirmationModal(card, item, $index) {
    this.modalItem = {
      card,
      item,
      $index,
    };
    this.showConfirmationModal = true;
  }

  hideConfirmationModal() {
    this.modalItem = {};
    this.showConfirmationModal = false;
  }
}

TechDoc.$inject = ['$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  '$location',
  '$anchorScroll',
];

export const techDoc = {
  template: techdoctpl,
  controller: TechDoc,
};
